<script>
    import { fade } from 'svelte/transition';
</script>

<div class="arsize_loader" transition:fade={ {duration: 200} }>
    <div class="arsize_loader_caption">
        <div class="arsize_load">
            <div class="arsize_loader_cube arsize_loader-1"></div>
            <div class="arsize_loader_cube arsize_loader-2"></div>
            <div class="arsize_loader_cube arsize_loader-4"></div>
            <div class="arsize_loader_cube arsize_loader-3"></div>
        </div>
    </div>
</div>

<style>
    .arsize_loader {
        align-items: center;
        display: flex;
        height: 120px;
        width: 100%;
        position: absolute;
        top: 100px;
    }
    .arsize_loader_caption {
        margin: 0 auto;
    }
    .arsize_load {
        width: 73px;
        height: 73px;
        margin: 0 auto;
        margin-top: 49px;
        position: relative;
        transform: rotateZ(45deg);
    }
    .arsize_loader_cube {
        position: relative;
        transform: rotateZ(45deg);
        width: 50%;
        height: 50%;
        float: left;
        transform: scale(1.1);
    }
    .arsize_loader_cube:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #34495e;
        animation: arsize_loader 2.76s infinite linear both;
        transform-origin: 100% 100%;
    }
    .arsize_loader-2 {
        transform: scale(1.1) rotateZ(90deg);
    }
    .arsize_loader-3 {
        transform: scale(1.1) rotateZ(180deg);
    }
    .arsize_loader-4 {
        transform: scale(1.1) rotateZ(270deg);
    }
    .arsize_loader-2:before {
        animation-delay: 0.35s;
    }
    .arsize_loader-3:before {
        animation-delay: 0.69s;
    }
    .arsize_loader-4:before {
        animation-delay: 1.04s;
    }
    @keyframes arsize_loader {
        0%,
        10% {
            transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
        75% {
            transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
        100% {
            transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }
</style>